import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import DateRangePickerOTA from '~/features/base/components/DateRangePickerOTA/DateRangePickerOTA';
import { validateHwSerials } from '~/features/base/utils/hwSerialValidator';
import SerialNumbersFormItem from '~/features/base/components/forms/SerialNumbersFormItem';
import { createCustomPresets } from '~/features/base/utils/customPresets';
import {
    MAX_DEVICES
} from '~/features/devices/components/dialogs/DownloadLogRequestBulk/DownloadLogRequestsInBulkDialog';

interface DownloadLogRequestFormProps {
}

const DownloadLogRequestForm: React.FC<DownloadLogRequestFormProps> = ({}) => {
    const { control } = useFormContext();
    const presetsWithoutLast30 = createCustomPresets(false).filter(p => p.id !== 30);

    return (
        <form>
            <div className='form-group'>
                <Controller
                    control={control}
                    name='serialNumberList'
                    defaultValue={[]}
                    rules={{
                        validate: {
                            maxLength: (serialNumbers: string[]) =>
                                serialNumbers.length <= MAX_DEVICES || `Maximum ${MAX_DEVICES} devices allowed`,
                            validSerials: (serialNumbers: string[]) =>
                                validateHwSerials(serialNumbers)
                        },
                        required: 'This field is required',
                    }}
                    render={({ field: { onChange, value }, fieldState: { error } }) => (
                        <>
                            <SerialNumbersFormItem
                                label={'intl-msg:serialNumberList'}
                                serialNumbers={value}
                                disabled={false}
                                onChange={({ serialNumbers }) => {
                                    onChange(serialNumbers);
                                }}
                            />
                            {error?.message && (
                                <div className={'form-group has-feedback has-error padding-bottom-15'}>
                                    <span className='help-block'>
                                        <span>{error.message}</span>
                                    </span>
                                </div>
                            )}
                        </>
                    )}
                />
                <label className='control-label'>
                    <FormattedMessage id='intl-msg:timeRange'/>
                </label>
                <Controller
                    control={control}
                    name='dateInput'
                    rules={{
                        required: true,
                        validate: {
                            isValidDateRange: (value) => {
                                const minDate = moment('1970-01-01');
                                if (moment(value.startValue).isBefore(minDate)) {
                                    return 'intl-msg:form:minDateError';
                                }
                                return true;
                            },
                        }
                    }}
                    render={({ field, fieldState: { error } }) => (
                        <DateRangePickerOTA
                            customPresets={presetsWithoutLast30}
                            hasError={!!error}
                            errorMsg={error?.message as string}
                            initialStartValue={field.value?.startValue}
                            initialEndValue={field.value?.endValue}
                            onRangeChange={(startValue, endValue) => {
                                field.onChange({ startValue, endValue });
                            }}
                        />
                    )}
                />
            </div>
        </form>
    );
};

export default DownloadLogRequestForm;
